import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {addDays, differenceInDays, format, isSameDay, startOfMonth} from 'ag-common/facades'
import {CalendarConfig} from '#tools/calendarConfig'

const CalendarHeaderWeekly = ({
  date,
  startOfCalendar,
  endOfCalendar,
  calendarType,
  setDate = null,
  setCalendarType = null,
  isDashboardView = false,
  scrollLeftControl: ScrollLeftControl = null,
  scrollRightControl: ScrollRightControl = null,
  calendarTypeButtons: CalendarTypeButtons = null,
  handleClickMonth,
}) => {
  const numberOfDays = differenceInDays(endOfCalendar, startOfCalendar) + 1
  const {getBorderColor} = CalendarConfig[calendarType]

  const gridColumnOffset = isDashboardView ? 0 : 1
  const gridTemplateColumns = isDashboardView
    ? `repeat(${numberOfDays}, 1fr)`
    : `284px repeat(${numberOfDays}, 1fr) 40px`

  return (
    <div className="calendar__header calendar__header--weekly" style={{gridTemplateColumns}}>
      <button
        type="button"
        className="calendar__current-week-button"
        onClick={() => handleClickMonth(startOfMonth(date))}
        disabled={!setCalendarType || !setDate}
        style={{gridColumn: `${1 + gridColumnOffset} / ${-1 - gridColumnOffset}`}}>
        {`KW ${format(startOfCalendar, 'ww MMMM yyyy')}`}
      </button>
      <div className="calendar__controls calendar__controls--left">
        <CalendarTypeButtons />
        <ScrollLeftControl />
      </div>
      {_.times(numberOfDays, n => (
        <div
          key={`${calendarType}-${addDays(startOfCalendar, n)}`}
          data-date={addDays(startOfCalendar, n)}
          className="calendar__placeholder"
          style={{gridColumn: n + 2, borderColor: getBorderColor(addDays(startOfCalendar, n))}}
        />
      ))}
      {_.times(numberOfDays, n => {
        const day = addDays(startOfCalendar, n)
        const currentWeekClass = isSameDay(new Date(), day) ? 'calendar__week--current' : ''
        return (
          <div
            key={addDays(startOfCalendar, n)}
            data-date={addDays(startOfCalendar, n)}
            className={`calendar__week ${currentWeekClass}`}
            style={{gridColumn: n + 2}}>
            <span className="calendar__kw__header">{`${format(day, 'eeeeee')} ${format(day, 'd.M.')}`}</span>
          </div>
        )
      })}
      <div className="calendar__controls calendar__controls--right">
        <ScrollRightControl />
      </div>
    </div>
  )
}

CalendarHeaderWeekly.propTypes = {
  startOfCalendar: PropTypes.object.isRequired,
  endOfCalendar: PropTypes.object.isRequired,
  setCalendarType: PropTypes.func.isRequired,
  scrollLeftControl: PropTypes.func,
  scrollRightControl: PropTypes.func,
  calendarTypeButton: PropTypes.func,
  handleClickMonth: PropTypes.func,
}

export default CalendarHeaderWeekly
